<button
  type="button"
  class="flex gap-3 items-center w-full py-2 px-4 cursor-pointer text-start text-sm"
  [ngClass]="
    {
      destructive:
        'bg-surface dark:bg-surface-darkmode hover:bg-surface-highlight dark:hover:bg-surface-highlight-darkmode text-on-error-soft dark:text-on-error-soft-darkmode',
      default:
        'bg-surface dark:bg-surface-darkmode hover:bg-surface-highlight dark:hover:bg-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode',
      admin:
        'bg-admin dark:bg-admin-darkmode hover:bg-admin-highlight dark:hover:bg-admin-highlight-darkmode text-on-admin dark:text-on-admin-darkmode',
    }[mode()]
  "
>
  @if (icon()) {
    <div>
      <ng-icon [name]="icon()" size="20" class="!block" />
    </div>
  }
  <div>
    <ng-content />
  </div>
</button>
